import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OperationModeInterval, WeekFilterKeys} from '../object-week-filter.model';

/**
 * Режим работы объекта
 * дни недели: 0 - вс, 1 - пн, 2 - вт, 3 - ср, 4 - чт, 5 - пт, 6 - сб, 7 - доп. день 1, 8 - доп. день 2
 * часовые интервалы в минутах от 0 до 1440 приводятся к формату чч:мм
 */
@Component({
  selector: 'app-object-scheduler-operation-mode',
  templateUrl: './object-scheduler-operation-mode.component.html',
  styleUrls: ['./object-scheduler-operation-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ObjectSchedulerOperationModeComponent implements OnInit {
  @Input() id: number;
  @Input() operationMode: OperationModeInterval;
  @Output() addOperationModeInterval = new EventEmitter();
  @Output() removeOperationModeInterval = new EventEmitter();

  public dtStart;
  public dtEnd;
  objectKeys = Object.keys;

  realDaysFilter = { $or: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] };
  customDaysFilter = { $or: ['d1', 'd2'] };

  constructor() {
  }

  ngOnInit() {
    this.dtStart = new Date();
    this.dtEnd = new Date();

    if (this.operationMode.start) {
      const parts = this.operationMode.start.split(':');
      this.dtStart.setHours(parseInt(parts[0], 10));
      this.dtStart.setMinutes(parseInt(parts[1], 10));
    }

    if (this.operationMode.end) {
      const parts = this.operationMode.end.split(':');
      this.dtEnd.setHours(parseInt(parts[0], 10));
      this.dtEnd.setMinutes(parseInt(parts[1], 10));
    }

  }

  /**
   * Выбрать один или несколько дней недели
   * @param days - массив строковых ключей для дней неделеи, которые нужно выбрать
   */
  public toggleDay(days: WeekFilterKeys[]) {
    const currentToggleStatus = days.reduce((before, cur) => this.operationMode.days[cur] && before, true);
    days.forEach(day => this.operationMode.days[day] = !currentToggleStatus);
  }

  /**
   * Обработка изменений начальной и конечной даты
   */
  public setOperationMode() {
//    this.operationMode.start = formatNumberToTime(this.operationMode.start);
//    this.operationMode.end =  formatNumberToTime(this.dtEnd.getHours() * 60 + this.dtEnd.getMinutes());
  }
  public set24OperationMode() {
    this.operationMode.start = '00:00';
    this.operationMode.end =  '24:00';
  }


  public clearTime(handler) {
    this.operationMode[handler] = '';
  }

}
